import { Link } from "react-router-dom";
import "./PricingCardStyle.css";

import React from 'react'

const PricingCard = () => {
  return (
    <div className="pricing">
        <div className="card-container">
            <div className="card">
                <h3>- Portfolio -</h3>
                <h4>A partir de:</h4>
                <span className="bar"></span>
                <p className="btc">$ 200</p>
                <p>- 1 week -</p>
                <p>- Featured -</p>
                <p>- Responsive Design -</p>
                <Link to ="/contact" className="btn">
                PURCHASE 
                </Link>
            </div>

            <div className="card">
                <h3>- Site Vitrine basic -</h3>
                <h4>A partir de:</h4>
                <span className="bar"></span>
                <p className="btc">$ 400</p>
                <p>- 3 weeks -</p>
                <p>- Featured -</p>
                <p>- Responsive Design -</p>
                <Link to ="/contact" className="btn">
                PURCHASE
                </Link>
            </div>

            <div className="card">
                <h3>- Autre -</h3>
                <h4>A partir de:</h4>
                <span className="bar"></span>
                <p className="btc">$ ---</p>
                <p>-  -</p>
                <p>- Featured -</p>
                <p>- Responsive Design -</p>
                <Link to ="/contact" className="btn">
                PURCHASE
                </Link>
            </div>
        </div>
    </div>
  )
}

export default PricingCard